/** GA4 event names for the KiTa wedge funnel and UDD/UCI loops. */
export const ANALYTICS = {
  school_alias_viewed: "school_alias_viewed",
  school_alias_copied: "school_alias_copied",
  school_inbox_viewed: "school_inbox_viewed",
  school_calendar_tap: "school_calendar_tap",
  school_ics_download: "school_ics_download",
  school_guest_cta: "school_guest_cta",
  school_first_extraction_seen: "school_first_extraction_seen",
  kita_reminder_tap: "kita_reminder_tap",
  kita_reminder_complete: "kita_reminder_complete",
  kita_reminder_promise_shown: "kita_reminder_promise_shown",
  briefing_push_tap: "briefing_push_tap",
  wedge_complete: "wedge_complete",
  kita_landing_view: "kita_landing_view",
  erste_haushalte_tap: "erste_haushalte_tap",
  erste_haushalte_link_copied: "erste_haushalte_link_copied",
  improvement_idea_submitted: "improvement_idea_submitted",
  capture_started: "capture_started",
  capture_confirmed: "capture_confirmed",
  capture_saved: "capture_saved",
  share_prompt_shown: "share_prompt_shown",
  share_prompt_dismissed: "share_prompt_dismissed",
};

export const AUTH_REDIRECT_STORAGE_KEY = "albis.authRedirect";
